/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import teamImage from '../../../../../assets/images/matchoffice_team.jpg';
import QuickSearchFormWrapper from '../QuickSearchForm/QuickSearchForm';
import './AboutUsLeftPart.sass';


class AboutUsLeftPart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  render() {
    const { about } = this.props.urls;
    const { quotePath, formAuthToken, formPostUrl } = this.props;

    return (
      <div>
        <div className="col-md-9">
          <h1 className="main-color bold">{I18n.t('about_us.page.title')}</h1>
          <div className="row">
            <div
              className="col-sm-6 about-description-text"
              dangerouslySetInnerHTML={{ __html: I18n.t('about_us.page.description') }}
            />
            <div className="col-sm-6">
              <div className="team-image-wrapper">
                <img src={teamImage} alt="Matchoffice team" title="Matchoffice team" />
              </div>
            </div>
          </div>


          <hr />

          <div className="row">
            <div className="col-sm-7">
              <h2 className="benefits-title">{I18n.t('about_us.page.advantages')}</h2>
              <ul
                className="list-advantages"
                dangerouslySetInnerHTML={{ __html: I18n.t('about_us.page.advantages_list') }}
              />
            </div>

            {quotePath && (
              <div className="col-sm-5 quote-wrapper">
                <img src={quotePath} alt="quote" title="quote team" />
              </div>
            )}

          </div>

          <hr />

          <div className="row contact-wrapper">
            <div
              className="col-sm-6"
              dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.contacts') }}
            />
            <div className="col-sm-6">
              <button type="button" className="button--big-orange" onClick={this.handleShow}>
                {I18n.t('about_us.page.offers_button')}
              </button>
            </div>
            <Modal show={this.state.showModal} onHide={this.handleClose} backdrop='static'>
              <Modal.Body>
                <button type="button" className="close" onClick={this.handleClose}>&nbsp;</button>
                <QuickSearchFormWrapper aboutUsPath={formPostUrl} formAuthToken={formAuthToken} />
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

AboutUsLeftPart.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
  quotePath: PropTypes.string,
  formAuthToken: PropTypes.string,
};

AboutUsLeftPart.defaultProps = {
  urls: {},
  quotePath: '',
  formAuthToken: '',
};

export default AboutUsLeftPart;
